import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-distribution-dialog',
  templateUrl: './distribution-dialog.component.html',
  styleUrls: ['./distribution-dialog.component.css']
})
export class DistributionDialogComponent implements OnInit {
  selectedView: string = "geochart";
  productId: string;
  gcp: string;
  batchNum: string;
  gln: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.productId = this.data.productId;
    this.gcp = this.data.gcp;
    this.batchNum = this.data.batchNum;
    this.gln = this.data.gln;
  }
}
